 $(document).ready(function(){
          /// Main search input
   $('.see_all_result_mobile').hide();
        var jQuery_1_3_2 = $.noConflict(true);
          $('.search-header-icon').on('click', function(e){
              $(this).closest('#search-modal').toggleClass('focus', e.type == 'focusin');  });
          /// Live search
          var preLoadLoadGif = $('<img src="" />');
          var searchTimeoutThrottle = 500;
          var searchTimeoutID = -1;
          var currReqObj = null;
          var collection = 'collections'; 
          var $mainbox = $('.util-area');  
         var product_count = 0;
        var page_count = 0;
          //var $resultsBox = $('<div class="results-box" />').appendTo('.util-area');
         var $products_box = $('<div class="products_box" />').appendTo('.util-area');
//          var $page_box = $('<div class="page_box" />').appendTo('.util-area');
        
          $('#search-modal input[type="text"]').bind('keyup change', function(){
              //Only search if search string longer than 2, and it has changed
          if($(this).val().length > 0 && $(this).val() != $(this).data('oldval')) {
                  //Reset previous value
                  $(this).data('oldval', $(this).val());
                  product_count = 0;
                  page_count = 0;
                  // Kill outstanding ajax request
                  if(currReqObj != null) currReqObj.abort();

                  // Kill previous search
                  clearTimeout(searchTimeoutID);

                  var $form = $(this).closest('form');

                  //Search term
                  var term =  $form.find('input[name="q"]').val() ;

                  //URL for full search page
                  var linkURL = $form.attr('action') + '?type=page,product,article&q=' + term;
            		console.log(linkURL);
            		console.log($().jquery);
                  //Show loading
                 // $resultsBox.html('<div class="load"></div>');
                 $products_box.html('<div class="load"></div>');
//                  $page_box.html('<div class="load"></div>');

                  // Do next search (in X milliseconds)
                  searchTimeoutID = setTimeout(function(){
                      //Ajax hit on search page
                    
                    	  $products_box.empty();
//                           $page_box.empty();
                    	 var q = term;
     					 var b = '&resources[type]=product,page,article';
                    
                    
                    	  var requestResponse;
                          fetch("/search/suggest.json?q="+term+"&resources[type]=product&resources[options][fields]=body,tag,title,product_type,variants.title,variants.barcode,variants.sku,vendor&limit=500")
                            .then((response) => {
                              requestResponse = response;
                              return response.text();
                             })
                            .then((text) => {
                               
                               var json = $.parseJSON(text);
                            	var product=json.resources.results.products;
                            	console.log(product);
                            	var $mainrow = $('<div class="main-product-box"><div class="see_all_products"><span>See all Results</span></div> </div>');
                            
                            	for (let i = 0; i < product.length; i++) {
                                       var $row = $('<a></a>').attr('href', product[i].url);
                                       $row.append('<div class="grid__cell"><div class=""><img src="' + product[i].featured_image.url + '" /></div><div class="d-title">'+product[i].title+'</div><div class="price">'+Shopify.formatMoney(product[i].price).replace('.00','')+'</div></div>');
                                     $mainrow.append($row);

                                 }
                            	  $products_box.append($mainrow);
                            	
                            if(product.length>0){
                                   $('.see_all_products').text('See all Results');
                                   $('.see_all_result_mobile').text('See all Results');
                                  }else{
                                       $('.see_all_products').text('No product found.')
                                       $('.see_all_result_mobile').text('No product found.')
                                    }
                                               
                                  $('.see_all_products').click(function(){
                                    
                                    //console.log("/search/?type=product&q="+term+"")

                                    window.location="/search?type=product&options%5Bprefix%5D=last&q="+term+"";

                                  });
                            	  $('.see_all_result_mobile').click(function(){

                                   // window.location="/search/?type=product&q="+term+"";

                                  });
                            	if(isMobile()){
                            		$('.see_all_result_mobile').show();
                            	}
                            	

                            })
                            .catch((error) => {
                              console.error(error);
                            });
                  
                    
                    
                    
//                  

                  }, searchTimeoutThrottle);
              } else if ($(this).val().length <1) {
                  //Deleted text? Clear results
                  $products_box.empty();
               $('.see_all_result_mobile').hide();
                       
              }
          }).attr('autocomplete', 'off').data('oldval', '');         

          //Search box should mimic live search string: products only, partial match
          $('.search-form, #search-form').on('submit', function(e){
            e.preventDefault();
            var term = $(this).find('input[name="q"]').val();
            var linkURL = $(this).attr('action') + '?type=product&options%5Bprefix%5D=last&q=' + term;
            window.location = linkURL;
          });

          // search ends
      });

	isMobile = function(){
        var isMobile = window.matchMedia("only screen and (max-width: 1160px)");
        return isMobile.matches ? true : false
    }
    
    window.onresize = function() {
      console.log(isMobile())
        if(isMobile()){
          if($('#search-modal input[type="text"]').val().length > 0 ){
           	$('.see_all_result_mobile').show();
          }
        }else{
            	$('.see_all_result_mobile').hide();
        }
    }